import styled from 'styled-components'

import colors from 'styles/colors'

interface CheckboxProps {
    id: string
    value?: string
    label: string | JSX.Element
    checked: boolean
    handleOnChange: () => void
}

export const Checkbox = ({
    id,
    label,
    checked,
    handleOnChange
}: CheckboxProps) => {
    return (
        <CheckboxContainer>
            <input
                hidden
                id={id}
                type='checkbox'
                checked={checked}
                onChange={handleOnChange}
            />
            <CheckboxButton onClick={handleOnChange}>
                <CheckboxButtonCheck $checked={checked} />
            </CheckboxButton>
            <CheckboxLabel htmlFor={id}>{label}</CheckboxLabel>
        </CheckboxContainer>
    )
}

const CheckboxContainer = styled.div`
    align-items: center;
    display: flex;
`

const CheckboxButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0.1rem solid #676e7dcc;
    border-radius: 50%;
    box-shadow: 0 0 0.2rem #d5d7da;
    height: 2rem;
    min-width: 2rem;
    margin-right: 1rem;
    background: transparent;
    cursor: pointer;
    color: ${colors.blueLighter};
    font-size: 1.25rem;
    -webkit-tap-highlight-color: transparent;
`

interface CheckboxButtonCheckProps {
    $checked?: boolean
}

const CheckboxButtonCheck = styled.div<CheckboxButtonCheckProps>`
    border-radius: 50%;
    height: 1rem;
    width: 1rem;
    background-color: ${colors.blueLighter};
    transform: ${props => (props.$checked ? 'scale(1)' : 'scale(0)')};
    transition: 0.2s all;
`
const CheckboxLabel = styled.label`
    font-size: 1.4rem;
    font-weight: 500;
    color: ${colors.bluishGray};
    cursor: pointer;
    user-select: none;
    -webkit-tap-highlight-color: transparent;

    &:focus {
        outline: none;
    }

    a {
        color: ${colors.blue};
        text-decoration: none;
    }
`
